import React from 'react';
import { CTA } from '../../../components/CTA';
import { PhoneIcon } from '../../../components/Icons/PhoneIcon';
import { Link } from '../../../components/Link';
import { Modal } from '../../../components/Modal';
import { TrackComponent } from '../../../components/TrackComponent';
import { __ } from '../../../helpers/TranslationService';
import { IAdvisor } from '../../../reducers/contactPage';
import { AdvisorModal } from '../AdvisorModal';

interface IProps {
    advisor: IAdvisor;
    cleanModal: () => void;
}

export function Advisor(props: IProps) {
    const [showModal, setShowModal] = React.useState(false);

    const phone = props.advisor.phone.trim();
    const companies = props.advisor.companies.map(({ title }) => title).join(', ');
    const languages = props.advisor.languages?.toString() ?? '';

    const TrackableLinkCall = TrackComponent(Link, {
        category: 'mobile-contact page',
        action: 'call agent',
        label: props.advisor.name,
    });

    const closeModal = () => {
        props.cleanModal();
        setShowModal(false);
    };

    return (
        <div className="advisorContainer">
            {showModal && (
                <Modal isOpen={showModal} onClose={closeModal}>
                    <AdvisorModal
                        image={props.advisor.image}
                        companies={companies}
                        name={props.advisor.name}
                        phone={phone}
                        languages={languages}
                    />
                </Modal>
            )}

            <AdvisorImage image={props.advisor.image} />
            <div className="advisorDetails advisorCard">
                <h4>{props.advisor.name}</h4>
                <p>{companies}</p>

                <div className="invisibleMobile">
                    {/* giving the text inside the btn some breathing room */}
                    <CTA
                        wrapperStyle={{
                            display: 'inline-flex',
                            padding: '10px 40px 10px 20px', // right arrow is + 20px
                            fontSize: 15,
                        }}
                        onClick={() => setShowModal(true)}
                    >
                        <span>{__('make contact', 'dreamlines')}</span>
                    </CTA>
                </div>

                <div className="visibleMobile">
                    <CTA
                        arrowStyle={{ display: 'none' }}
                        wrapperStyle={{
                            maxWidth: 200,
                            padding: '10px 5px',
                            fill: 'white',
                        }}
                    >
                        <TrackableLinkCall href={`tel:${phone}`}>
                            <AdvisorPhone phone={phone} />
                        </TrackableLinkCall>
                    </CTA>
                </div>
            </div>
        </div>
    );
}

export const AdvisorImage = ({ image }: { image: string }) => (
    <figure
        className="advisorAvatar"
        style={{
            background: `url('${image}') center top no-repeat`,
            backgroundSize: '100% auto',
        }}
    />
);
export const AdvisorPhone = ({ phone }: { phone: string }) => (
    <span className="phoneSpan">
        <PhoneIcon /> {phone}
    </span>
);
